import { DEVICE_TYPES } from "utils/helpers/enums/shared.enum";

export class DeviceTokenDTO{
    deviceType: DEVICE_TYPES = DEVICE_TYPES.WEB
    token: string = ''
    deviceId: string = ''

    constructor(data: Partial<DeviceTokenDTO> = {}){
        Object.assign(this,data);
    }
}